<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">

            <!-- <div class="search">
              <form autocomplete="off" >
                <input type="text" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter" placeholder="search">
              </form>
              <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
            </div> -->
            <!-- <button data-toggle="modal" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> Add</button> -->
            <div class="filter-icon">
              <!-- <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i> -->
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshTickets()"></i>
            </div>
          </div>
        </div>
        <div class="row map-block">
          <div class="col-md-8 col-lg-8" [ngClass]="{'col-lg-4 col-md-4': showFilter || detailShow}">
            <div class="map-container" [ngClass]="[isFullscreen ? bi_fullscreen : '']">
              <div class="map-frame">
                <i class="bi bi-fullscreen" [ngClass]="isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'"
                  (click)="toggleFullscreen()"></i>
                <div id="map">
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 detailShow" *ngIf="detailShow">

            <div class="service-data" *ngFor="let viewData of singleObjectInfoData">
              <div class="close-i">
                <i class="bi bi-x-lg" (click)="closeDetailView()"></i>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.objectInfoId' | translate }} :</label>
                    <p>{{viewData.objectInfoId || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.name' | translate }} :</label>
                    <p>{{viewData.name || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.givenName' | translate }} :</label>
                    <p>{{viewData.givenName || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.serialNumberCheckBox">
                    <label>{{ 'object-info.serialNumber' | translate }} :</label>
                    <p>{{viewData.serialNumber || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.group' | translate }} :</label>
                    <p>{{viewData.group || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.type' | translate }} :</label>
                    <p>{{viewData.type || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.modelCheckBox">
                    <label>{{ 'object-info.model' | translate }} :</label>
                    <p>{{viewData.model || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.makeCheckBox">
                    <label>{{ 'object-info.make' | translate }} :</label>
                    <p>{{viewData.make || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.objectCondition' | translate }} :</label>
                    <p>{{viewData.objectCondition || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>Asset Status :</label>
                    <p>{{viewData.assetStatus || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.originalCostCheckBox">
                    <label>{{ 'object-info.originalCost' | translate }} :</label>
                    <p>{{viewData.originalCost || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.currentCostCheckBox">
                    <label>{{ 'object-info.currentCost' | translate }} :</label>
                    <p>{{viewData.currentCost || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.branchCheckBox">
                    <label>{{ 'object-info.branch' | translate }} :</label>
                    <p>{{viewData.branch || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                    <label>{{ 'object-info.department' | translate }} :</label>
                    <p>{{viewData.department || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.location' | translate }} :</label>
                    <p>{{viewData.location || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.country' | translate }} :</label>
                    <p>{{viewData.country || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                    <p>{{viewData.provinceOrState || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.zone' | translate }} :</label>
                    <p>{{viewData.zone || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.postalCode' | translate }} :</label>
                    <p>{{viewData.postalCode || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.city' | translate }} :</label>
                    <p>{{viewData.city || '--'}}</p>
                  </div>


                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.createdDate' | translate }} :</label>
                    <p>{{viewData.createdDate | date}}</p>
                  </div>
                  <!-- 
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.acquisitionDate' | translate }} :</label>
                    <p>{{viewData.acquisitionDate || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                    <label>{{ 'object-info.salvageValue' | translate }} :</label>
                    <p>{{viewData.salvageValue || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                    <label>{{ 'object-info.depreciationMethod' | translate }} :</label>
                    <p>{{viewData.depreciationMethod || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                    <label>{{ 'object-info.assetLifeNumber' | translate }} :</label>
                    <p>{{viewData.assetLifeNumber || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.asset_Category' | translate }} :</label>
                    <p>{{viewData.asset_Category || '--'}}</p>
                  </div> -->

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.alive' | translate }} </label>
                    <p>{{viewData.alive? 'Yes': 'No'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.deployCurrentLocation' | translate }} </label>
                    <p>{{viewData.deployCurrentLocation? 'Yes': 'No'}}</p>
                  </div>
                  <div class="col-md-12 col-lg-12 qr-code">
                    <label>{{ 'object-info.qr_code' | translate }} :</label>
                  </div>


                  <div class="col-md-12 col-lg-12">
                    <div class="image-container" style="margin-top: 20px;">
                      <div class="image-header image-header1">
                        <h5>{{ 'object-info.images' | translate }}</h5>
                      </div>


                      <div class="image-content-block">
                        <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                          <p>{{image.name}}</p>
                          <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                          <!-- <button (click)="removeImage(i)">Remove</button> -->
                        </div>
                        <div class="large-image-view" *ngIf="largeImage != ''">
                          <img src="{{largeImage}}" alt="">
                          <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                        </div>
                      </div>



                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
                    <h5 class="data-list-title">{{ 'object-info.nameValue' | translate }}</h5>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list"
                    *ngIf="viewData.nameValue && viewData.nameValue.length != 0">

                    <div class="list-block">
                      <ul class="ui-tree">
                        <ng-container *ngFor="let item of viewData.nameValue">
                          <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                        </ng-container>
                      </ul>

                      <ng-template #renderNode let-node>
                        <li>
                          <strong>{{ node.key }}:</strong> {{ node.value }}
                          <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                            <ng-container *ngFor="let child of node.keyValue">
                              <ng-container
                                *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                            </ng-container>
                          </ul>
                        </li>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12"
                    *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">
                    <h5 class="data-list-title">{{ 'object-info.performanceMatrix' | translate }} </h5>
                  </div>


                  <div class="col-md-12 col-lg-12" *ngIf="viewData.warranty && userCred.userType == 'Accounts'">
                    <h5 class="data-list-title">{{ 'object-info.warranty' | translate }}</h5>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list"
                    *ngIf="viewData.warranty && userCred.userType == 'Accounts'">
                    <div class="list-block">
                      <ul class="ui-tree">
                        <li *ngFor="let warrantyInfo of viewData.warrantyInfo">
                          <strong>{{ warrantyInfo.key }}:</strong> {{ warrantyInfo.value }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" *ngIf="viewData.purchase && userCred.userType == 'Accounts'">
                    <h5 class="data-list-title">{{ 'object-info.purchase' | translate }}</h5>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list"
                    *ngIf="viewData.purchase && userCred.userType == 'Accounts'">
                    <div class="list-block">
                      <ul class="ui-tree">
                        <li *ngFor="let purchaseInfo of viewData.purchaseInfo">
                          <strong>{{ purchaseInfo.key }}:</strong> {{ purchaseInfo.value }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list"
                    *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0 && !editPerformanceMatrix">

                    <div class="list-block">
                      <ul class="ui-tree">
                        <ng-container *ngFor="let item of viewData.performanceMatrix">
                          <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                        </ng-container>
                      </ul>

                      <ng-template #renderNode1 let-node>
                        <li>
                          <strong>{{ node.key }}:</strong> {{ node.value }}
                          <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                            <ng-container *ngFor="let child of node.keyValue">
                              <ng-container
                                *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                            </ng-container>
                          </ul>
                        </li>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" style="padding: 0;"
                    *ngIf="maintenanceScheduleList && maintenanceScheduleList.length != 0">
                    <h5 class="maintenance-list-title">{{ 'maintenance-schedule.title' | translate }}</h5>

                    <div class="maintenance-list-block">
                      <div class="list" *ngFor="let list of maintenanceScheduleList">

                        <div class="list1">
                          <div>
                            <label>{{ 'maintenance-schedule.maintenanceType' | translate }} :</label>
                            <p>{{getMaintenanceType(list.maintenanceType) || '--'}}</p>
                          </div>
                          <div>
                            <label>{{ 'maintenance-schedule.frequency' | translate }} :</label>
                            <p>{{list.frequency || '--'}}</p>
                          </div>
                          <div>
                            <label>{{ 'maintenance-schedule.nextDueDate' | translate }} :</label>
                            <p>{{list.nextDueDate || '--'}}</p>
                          </div>
                          <div>
                            <label>{{ 'maintenance-schedule.lastPerformed' | translate }} :</label>
                            <p>{{list.lastPerformed || '--'}}</p>
                          </div>
                        </div>
                        <div>
                          <label>{{ 'maintenance-schedule.description' | translate }} :</label>
                          <p>{{list.description || '--'}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" style="padding: 0;"
                    *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.repairList' | translate }}</h5>




                    <div class="repair-list-block">
                      <div class="list" *ngFor="let list of viewData.repairInfos">
                        <div>
                          <p><label>{{ 'object-info.repairDone' | translate }} :</label> {{list.description || '--'}}
                          </p>
                        </div>

                        <div class="dates">
                          <p><label>{{ 'object-info.repairGivenTo' | translate }} :</label> {{list.repairGivenTo ||
                            '--'}}</p>
                          <p><label>{{ 'object-info.userName' | translate }} :</label> {{list.userName || '--'}}</p>
                          <p><label>{{ 'object-info.phNo' | translate }} :</label> {{list.phNo || '--'}}</p>
                          <p><label>{{ 'object-info.emailId' | translate }} :</label> {{list.emailId || '--'}}</p>
                          <p><label>{{ 'object-info.repairGivenDate' | translate }} :</label> {{list.repairGivenDate |
                            date}}</p>
                          <p><label>{{ 'object-info.repairExpectedEndDate' | translate }} :</label>
                            {{list.repairExpectedEndDate | date}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" style="padding: 0;"
                    *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.connections' | translate }}</h5>

                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <label>{{ 'object-info.assetMonitoringFrequency' | translate }} :</label>
                        <p>{{viewData.assetMonitoringFrequency || '--'}}</p>
                      </div>

                      <div class="col-md-6 col-lg-6">
                        <label>{{ 'object-info.assetMonitoringTimeSpan' | translate }} :</label>
                        <p>{{viewData.assetMonitoringTimeSpan || '--'}}</p>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 col-lg-6" *ngFor="let connectionDetails of viewData.connectionDetails">
                        <label>{{connectionDetails.key || '--'}} :</label>
                        <p>{{connectionDetails.value || '--'}}</p>
                      </div>
                    </div>
                  </div>



                  <div class="col-md-12 col-lg-12" style="padding: 0;"
                    *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.assetHealth' | translate }}</h5>

                    <div class="row">
                      <div class="col-md-6 col-lg-6" *ngFor="let assetHealthList of viewData.assetHealth">
                        <label>{{assetHealthList.key || '--'}} :</label>
                        <p>{{assetHealthList.value || '--'}}</p>
                      </div>
                    </div>
                  </div>


                  <!-- 
                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                    <h5 class="repair-list-title">Repair List <span *ngIf="viewData.givenRepair" (click)="openRepairDone()">Repair Done</span></h5>
                    
                    <div class="repair-block" *ngIf="isRepairDone" [formGroup]="repairInfoForm">
                      <h5>Repair Done</h5>
                      <div class="form-group">
                        <label>Description</label>
                        <textarea name="" formControlName="description" id=""></textarea>
                      </div>

                      

                      <div class="action-repair">
                        <button type="button" class="btn btn-secondary" (click)="closeRepairDone()">Cancel</button>
                        <button type="button" (click)="addRepairInfos(false)" class="btn btn-primary">Repair Done</button>
                      </div>
                    </div>


                    <div class="repair-list-block">
                      <div class="list" *ngFor="let list of viewData.repairInfos">
                        <div>
                          <p><label>Description :</label> {{list.description || '--'}}</p>
                        </div>

                        <div class="dates">
                          <p><label>Company :</label> {{list.repairGivenTo || '--'}}</p>
                          <p><label>Name :</label> {{list.userName || '--'}}</p>
                          <p><label>Mobile :</label> {{list.phNo || '--'}}</p>
                          <p><label>Email :</label> {{list.emailId || '--'}}</p>
                          <p><label>Given Date :</label> {{list.repairGivenDate | date}}</p>
                          <p><label>Expected End Date :</label> {{list.repairExpectedEndDate | date}}</p>
                        </div>
                      </div>
                    </div>
                  </div> -->



                  <div class="nameValue" *ngIf="performance">
                    <div>
                      <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                      <div class="row keys-content">

                        <div class="col-md-12 col-lg-12 keysBlock">
                          <div class="form-group">
                            <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                            <p>{{viewData.assetPerformance?.timeSpan}}</p>

                          </div>

                          <div class="form-group">
                            <label for="">{{ 'object-info.uom' | translate }}</label>
                            <p>{{viewData.assetPerformance?.uom || '--'}}</p>
                          </div>

                          <div class="form-group">
                            <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                            <p>{{viewData.assetPerformance?.expectedOutput || '--'}}</p>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" style="padding: 0;"
                    *ngIf="viewData.tags && viewData.tags.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.tags' | translate }}</h5>
                    <div class="tag-list">
                      <p class="tag" *ngFor="let list of viewData.tags">{{list}}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4" style="padding-left: 0;">
            <!-- <input type="text" placeholder="search" class="form-control"> -->
            <div class="customerList">
              <!-- <div class="list">
                <p *ngFor="let list of objectInfoList" (click)="getObjectInfoById(list.objectInfoId)">{{list.givenName}}</p>
              </div> -->
              <div class="list">
                <div class="locate-filter">

                  <select name="" id="" class="form-control" [(ngModel)]="template">
                    <option value="" selected disabled> -- show by --</option>
                    <option value="{{list.name}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
                  </select>

                  <button (click)="clearObject()">{{ 'generic.clear' | translate }}</button>
                </div>
                <p [ngClass]="{'is-checked': list.isChecked}" *ngFor="let list of locationFilterList"
                  (click)="locationCheck($event, list)">
                  <!-- <input type="checkbox" (click)="$event.preventDefault()" [checked]="list.isChecked" > -->
                  <span></span>
                  {{list.zone}} - {{list.city}} - {{list.postalCode}}
                </p>
              </div>
              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
              </div>

              <div class="loader" *ngIf="!isLoading && locationFilterList.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
                </div>
              </div>
            </div>

          </div>

          <div class="col-lg-4 col-md-4" *ngIf="showFilter">
            <div class="filter-block">
              <div class="filters">
                <div class="filter-title">
                  <p>Filters</p>
                  <div class="filter-apply-button">
                    <button (click)="resetFilter()">Reset</button>
                    <button (click)="applyFilter()">Apply</button>
                  </div>
                </div>
                <div class="filter-section">

                  <!-- Model -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'modelFilter'"
                        (change)="onFilterSelect('modelFilter')" />
                      Model
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="modelFilter" [disabled]="!modelChecked" />
                  </div>

                  <!-- Make -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'makeFilter'"
                        (change)="onFilterSelect('makeFilter')" />
                      Make
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="makeFilter" [disabled]="!makeChecked" />
                  </div>

                  <!-- Type -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'typeFilter'"
                        (change)="onFilterSelect('typeFilter')" />
                      Type
                    </label>
                    <select class="form-control" [(ngModel)]="typeFilter" [disabled]="!typeChecked">
                      <option value="" selected disabled> -- Select Type --</option>
                      <option value="{{object.typeName}}" *ngFor="let object of objectTypeData;let i = index">
                        {{object.typeName}}</option>
                    </select>
                    <!-- <input type="text" class="form-control" [(ngModel)]="typeFilter" [disabled]="!typeChecked" /> -->
                  </div>

                  <!-- Group -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'groupFilter'"
                        (change)="onFilterSelect('groupFilter')" />
                      Group
                    </label>

                    <select class="form-control" [(ngModel)]="groupFilter" [disabled]="!groupChecked">
                      <option value="" selected disabled> -- Select Group --</option>
                      <option value="{{object.groupName}}" *ngFor="let object of objectGroupData;let i = index">
                        {{object.groupName}}</option>
                    </select>
                    <!-- <input type="text" class="form-control" [(ngModel)]="groupFilter" [disabled]="!groupChecked" /> -->
                  </div>

                  <!-- Serial Number -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'serialNumberFilter'"
                        (change)="onFilterSelect('serialNumberFilter')" />
                      Serial Number
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="serialNumberFilter"
                      [disabled]="!serialNumberChecked" />
                  </div>

                  <!-- Object Condition -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'objectConditionFilter'"
                        (change)="onFilterSelect('objectConditionFilter')" />
                      Asset Condition
                    </label>
                    <select class="form-control" [(ngModel)]="objectConditionFilter"
                      [disabled]="!objectConditionChecked">
                      <option value="" disabled selected>-- Select Condition --</option>
                      <option value="Good">Good</option>
                      <option value="UnderRepair">Under Repair</option>
                      <option value="Scrap">Scrap</option>
                    </select>
                  </div>

                  <!-- Branch -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'branchFilter'"
                        (change)="onFilterSelect('branchFilter')" />
                      Branch
                    </label>
                    <select name="" id="" [(ngModel)]="branchFilter" [disabled]="!branchChecked" class="form-control">
                      <option value="" selected disabled> -- Select Branch --</option>
                      <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
                    </select>
                    <!-- <input type="text" class="form-control" [(ngModel)]="branchFilter" [disabled]="!branchChecked" /> -->
                  </div>

                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'locationFilter'"
                        (change)="onFilterSelect('locationFilter')" />
                      Location
                    </label>
                    <select name="" id="" [(ngModel)]="locationFilter" [disabled]="!locationChecked"
                      class="form-control">
                      <option value="" selected disabled> -- Select Location --</option>
                      <option value="{{list.zone}}" *ngFor="let list of locationFilterList">{{list.zone}} -
                        {{list.city}} - {{list.postalCode}}</option>
                    </select>
                  </div>

                  <!-- Department -->
                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'departmentFilter'"
                        (change)="onFilterSelect('departmentFilter')" />
                      Department
                    </label>
                    <select name="" id="" [(ngModel)]="departmentFilter" [disabled]="!departmentChecked"
                      class="form-control">
                      <option value="" selected disabled> -- select department --</option>
                      <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">
                        {{list.departmentName}}</option>
                    </select>
                    <!-- <input type="text" class="form-control" [(ngModel)]="departmentFilter" [disabled]="!departmentChecked" /> -->
                  </div>

                  <div class="form-group">
                    <label>
                      <input type="radio" name="filter" [checked]="selectedFilter === 'objectByTemplateFilter'"
                        (change)="onFilterSelect('objectByTemplateFilter')" />
                      Asset By Template
                    </label>
                    <select name="" id="" [(ngModel)]="objectByTemplateFilter" [disabled]="!objectByTemplateChecked"
                      class="form-control">
                      <option value="" selected disabled> -- select template --</option>
                      <option value="{{list.name}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
                    </select>
                    <!-- <input type="text" class="form-control" [(ngModel)]="departmentFilter" [disabled]="!departmentChecked" /> -->
                  </div>



                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container">
  <div class="review-box">
    <i class="fa-solid fa-thumbs-up up" (click)="vote('up')"></i>
    <span class="positive-value">{{ positivePercentage }}%</span>
  </div>
  <div class="review-indicator">
    <span class="positive-meter" [style.width.%]="positivePercentage"></span>
    <span class="negative-meter" [style.width.%]="negativePercentage"></span>
  </div>
  <div class="review-box">
    <span class="negative-value">{{ negativePercentage }}%</span>
    <i class="fa-solid fa-thumbs-down down" (click)="vote('down')"></i>
  </div>
</div> -->
<!-- <div class="labels">
  <span class="label-left">Good</span>
  <span class="label-right">Bad</span>
</div>
<div class="review-bar">
  <div 
    class="good" 
    [style.width.%]="goodPercentage"
    [title]="'Good Reviews: ' + goodCount">
  </div>
  <div 
    class="bad" 
    [style.width.%]="badPercentage"
    [title]="'Bad Reviews: ' + badCount">
  </div>
</div> -->


<!-- <div class="service-data" *ngFor="let viewData of singleObjectInfoData">
  <div class="form-group">
    <div class="row">
      <div class="col-md-6 col-lg-6">
        <label>Asset Id :</label>
        <p>{{viewData.objectInfoId || '--'}}</p>
      </div>
      <div class="col-md-6 col-lg-6">
        <label>Asset :</label>
        <p>{{viewData.name || '--'}}</p>
      </div>
      <div class="col-md-6 col-lg-6">
        <label>Name :</label>
        <p>{{viewData.givenName || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Serial Number :</label>
        <p>{{viewData.serialNumber || '--'}}</p>
      </div>
      <div class="col-md-6 col-lg-6">
        <label>Group :</label>
        <p>{{viewData.group || '--'}}</p>
      </div>
      <div class="col-md-6 col-lg-6">
        <label>Type :</label>
        <p>{{viewData.type || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Model :</label>
        <p>{{viewData.model || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Make :</label>
        <p>{{viewData.make || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Asset Condition :</label>
        <p>{{viewData.objectCondition || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Original Cost :</label>
        <p>{{viewData.originalCost || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Current Cost :</label>
        <p>{{viewData.currentCost || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Branch :</label>
        <p>{{viewData.branch || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Department :</label>
        <p>{{viewData.department || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Location :</label>
        <p>{{viewData.location || '--'}}</p>
      </div>

      <div class="col-md-6 col-lg-6">
        <label>Created Date :</label>
        <p>{{viewData.createdDate | date}}</p>
      </div>
      
      <div class="col-md-12 col-lg-12" *ngIf="imagesList && imagesList.length != 0">
        <div class="image-container" style="margin-top: 20px;">
          <div class="image-header image-header1">
            <h5>Images</h5>
          </div>
          <div class="image-content-block">
            <div class="image-single" *ngFor="let image of imagesList">
              <img src="{{image}}" (click)="selectLargeImage(image)" alt="">
            </div>
            <div class="large-image-view" *ngIf="largeImage != ''">
              <img src="{{largeImage}}" alt="">
              <button (click)="selectLargeImage('')">close</button>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-12 col-lg-12" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
        <h5 class="data-list-title">Specifications</h5>
      </div>

      <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
        
        <div class="list-block">
          <ul class="ui-tree">
            <ng-container *ngFor="let item of viewData.nameValue">
              <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
            </ng-container>
          </ul>

          <ng-template #renderNode let-node>
            <li>
              <strong>{{ node.key }}:</strong> {{ node.value }}
              <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                <ng-container *ngFor="let child of node.keyValue">
                  <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                </ng-container>
              </ul>
            </li>
          </ng-template>
        </div>
      </div>

      <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="maintenanceScheduleList && maintenanceScheduleList.length != 0">
        <h5 class="maintenance-list-title">Maintenance Schedule</h5>
        
        <div class="maintenance-list-block">
          <div class="list" *ngFor="let list of maintenanceScheduleList">
            
            <div class="list1">
                <div>
                  <label>Maintenance Type :</label> 
                  <p>{{getMaintenanceType(list.maintenanceType[0]) || '--'}}</p>
                </div>
                <div>
                  <label>Frequency :</label> 
                  <p>{{list.frequency[0] || '--'}}</p>
                </div>
                <div>
                  <label>Next Due Date :</label> 
                  <p>{{list.nextDueDate || '--'}}</p>
                </div>
                <div>
                  <label>Last Performed :</label> 
                  <p>{{list.lastPerformed || '--'}}</p>
                </div>
            </div>
            <div>
              <label>Description :</label> 
              <p>{{list.description || '--'}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
        <h5 class="repair-list-title">Repair List</h5>
        <div class="repair-list-block">
          <div class="list" *ngFor="let list of viewData.repairInfos">
            <div>
              <p><label>Description :</label> {{list.description || '--'}}</p>
            </div>

            <div class="dates">
              <p><label>Company :</label> {{list.repairGivenTo || '--'}}</p>
              <p><label>Name :</label> {{list.userName || '--'}}</p>
              <p><label>Mobile :</label> {{list.phNo || '--'}}</p>
              <p><label>Email :</label> {{list.emailId || '--'}}</p>
              <p><label>Given Date :</label> {{list.repairGivenDate | date}}</p>
              <p><label>Expected End Date :</label> {{list.repairExpectedEndDate | date}}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div> -->



<button style="display: none;" id="add-device-popup" data-toggle="modal" data-target="#deviceModal">Add Branch</button>

<div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.add' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
            <label>{{ 'object-info.name' | translate }} <span class="required">*</span></label>
            <select name="" id="" [(ngModel)]="objectTemplateId" class="form-control"
              (change)="getObjectTemplateById($event)">
              <option value="" selected disabled> -- Asset --</option>
              <option value="{{list.objectTemplateId}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
            </select>
          </div>

          <div *ngFor="let list of singleObjectTemplateData">

            <div class="form-group">
              <label>{{ 'object-info.givenName' | translate }} <span class="required">*</span></label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()" (cut)="false"
                (keydown)="filterInputByType($event, 'allText')" class="form-control" [(ngModel)]="givenName">
            </div>

            <div class="form-group" *ngIf="list.originalCost">
              <label>{{ 'object-info.originalCost' | translate }} <span class="required"
                  *ngIf="isOriginalCost">*</span></label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()" (cut)="false"
                (keydown)="filterInputByType($event, 'number')" class="form-control" [(ngModel)]="originalCost">
            </div>

            <div class="form-group" *ngIf="list.currentCost">
              <label>{{ 'object-info.currentCost' | translate }} </label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()" (cut)="false"
                (keydown)="filterInputByType($event, 'number')" class="form-control" [(ngModel)]="currentCost">
            </div>

            <div class="form-group">
              <label>{{ 'object-info.objectCondition' | translate }} <span class="required">*</span></label>
              <select name="" id="" [(ngModel)]="objectCondition" class="form-control"
                (change)="objectConditionChange()">
                <option value="" disabled> -- select condition --</option>
                <option *ngFor="let condition of assetConditions" [value]="condition.value">{{ condition.label }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>Asset Status</label>
              <select name="" id="" [(ngModel)]="assetStatus" class="form-control">
                <option value=""> -- </option>
                <option *ngFor="let list of assetStatusList" [value]="list.name">{{ list.name }}</option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ 'object-info.asset_Category' | translate }} <span class="required"
                  *ngIf="isAsset_Category">*</span></label>
              <select name="" id="" [(ngModel)]="asset_Category" class="form-control">
                <option value="" selected disabled> -- select asset category--</option>
                <option value="{{list.categoryName}}" *ngFor="let list of objectCategoryList">{{list.categoryName}}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ 'object-info.acquisitionDate' | translate }}</label>
              <input type="date" (keydown)="filterDateInput($event)" class="form-control" [(ngModel)]="acquisitionDate">
            </div>
            <!-- 
            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.salvageValue' | translate }} <span class="required" *ngIf="isSalvageValue">*</span></label>
              <input type="number" class="form-control" [(ngModel)]="salvageValue">
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.depreciationMethod' | translate }}</label>
              <select name="" id="" [(ngModel)]="depreciationMethod" (change)="depreciationMethodChange(depreciationMethod)" class="form-control">
                <option value="" selected disabled> -- select asset depreciation--</option>
                <option value="{{list.assetDepreciationMethodId}}" *ngFor="let list of assetDepreciationDataList">{{list.methodName}}</option>
              </select>
            </div>
            
            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.putToUseDate' | translate }} <span class="required" *ngIf="isPutToUseDate">*</span></label>
              <input type="date" (keydown)="filterDateInput($event)" class="form-control" [(ngModel)]="putToUseDate">
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.assetLifeNumber' | translate }} <span class="required" *ngIf="isAssetLifeNumber">*</span></label>
              <input type="number" class="form-control" (paste)="false" (contextmenu)="$event.preventDefault()"
(cut)="false" (keydown)="filterInputByType($event, 'number')" [(ngModel)]="assetLifeNumber">
            </div> -->

            <div class="form-group" *ngIf="list.branch">
              <label>{{ 'object-info.branch' | translate }}</label>
              <select name="" id="" [(ngModel)]="branch" class="form-control">
                <option value="" selected disabled> -- select branch --</option>
                <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.department">
              <label>{{ 'object-info.department' | translate }}</label>
              <select name="" id="" [(ngModel)]="department" class="form-control">
                <option value="" selected disabled> -- select department--</option>
                <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">{{list.departmentName}}
                </option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.make">
              <label>{{ 'object-info.make' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="make">
            </div>

            <div class="form-group" *ngIf="list.model">
              <label>{{ 'object-info.model' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="model">
            </div>

            <div class="form-group" *ngIf="list.serialNumber">
              <label>{{ 'object-info.serialNumber' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="serialNumber">
            </div>


            <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.objectQty' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="objectQty">
            </div>

            <!-- <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.objectUOM' | translate }}</label>
              <select class="form-control" [(ngModel)]="objectUOM" [ngModelOptions]="{standalone: true}">
                <option value="" selected disabled> -- Select Uom --</option>
                <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}</option>
              </select>
            </div> -->

            <!-- <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.availableQty' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="availableQty">
            </div> -->

            <div class="form-group">
              <label>{{ 'object-info.location' | translate }} <span class="required">*</span></label>
              <select name="" id="" [(ngModel)]="location" class="form-control">
                <option value="" selected disabled> -- select location --</option>
                <option value="{{loc.zone}}" *ngFor="let loc of locationFilterList">{{loc.zone}} - {{loc.city}} -
                  {{loc.postalCode}}</option>
              </select>
            </div>

            <!-- <div class="form-group">
              <label>Asset Status</label>
              <select name="" id="" [(ngModel)]="objectStatus" class="form-control">
                <option value="" selected disabled> -- select location --</option>
                <option value="{{list.city}}" *ngFor="let list of locationList">{{list.city}}</option>
              </select>
            </div>

            <div class="form-group">
              <label>Asset Status Color</label>
              <input type="text" [(ngModel)]="objectStatusColor" class="form-control">
            </div> -->

            <div class="form-group" *ngIf="isObjectColorCode">
              <label>{{ 'object-info.assetColor' | translate }}</label>
              <div class="asset-color">
                <input type="color" style="width: 100px;" class="" [(ngModel)]="objectColorCode">
                <input type="text" style="width: 250px;" class="" [(ngModel)]="objectColorCode">
              </div>
            </div>

            <div class="image-container" style="margin: 20px 0;">
              <div class="image-header image-header1">
                <h5>{{ 'object-info.icon' | translate }}</h5>
                <i *ngIf="icon == ''" (click)="addIconBtn()" class="bi bi-plus-circle"></i>
              </div>
              <div class="image-content-block" *ngIf="icon != ''">
                <div class="image-single">
                  <img src="{{icon}}" alt="">
                  <span (click)="removeIcon()">{{ 'generic.remove' | translate }}</span>
                </div>
              </div>

              <div hidden="true">
                <input #imageInput type="file" id="add-icon-btn" accept="image/*" hidden="true"
                  (change)="onIconChange($event)">
              </div>

            </div>


            <div class="image-container">
              <div class="image-header image-header1">
                <h5>{{ 'object-info.images' | translate }}</h5>
                <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i>
              </div>
              <div class="image-content-block">

                <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                  <p>{{image.name}}</p>
                  <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                  <button (click)="removeImage(i)">{{ 'generic.remove' | translate }}</button>
                </div>
                <div class="large-image-view" *ngIf="largeImage != ''">
                  <img src="{{largeImage}}" alt="">
                  <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                </div>
              </div>

              <div hidden="true">
                <input #imageInput type="file" id="add-TicketImage-btn" accept="image/*" hidden="true"
                  (change)="onTicketChange($event)">
              </div>
            </div>









            <div class="check-box">
              <p> {{ 'maintenance-schedule.title' | translate }} <i (click)="addMaintenance()"
                  class="bi bi-plus-circle"></i></p>
            </div>

            <div class="maintenance-schedule-block">
              <!-- <h5>Maintenance Schedule</h5> -->
              <div class="maintenance-schedule" *ngFor="let list of maintenanceList;let index = index">
                <span class="remove"><i (click)="removeMaintenance(index)" class="bi bi-x-lg"></i></span>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.description' | translate }}</label>
                  <textarea name="" [(ngModel)]="list.description" class="form-control" id=""></textarea>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.maintenanceType' | translate }}</label>
                  <select name="" id="" [(ngModel)]="list.maintenanceType" class="form-control">
                    <option value="" selected disabled> -- select maintenance type --</option>
                    <option value="{{list.value}}" *ngFor="let list of maintenanceType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.frequency' | translate }}</label>
                  <select name="" id="" [(ngModel)]="list.frequency" class="form-control">
                    <option value="" selected disabled> -- select frequency type --</option>
                    <option value="{{list.value}}" *ngFor="let list of frequencyType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.nextDueDate' | translate }}</label>
                  <input type="date" [min]="todayDate" class="form-control" [(ngModel)]="list.nextDueDate">
                </div>
              </div>
            </div>

            <div class="multiple-inputs"
              *ngIf="list.nameValue && list.nameValue != null && list.nameValue != undefined && list.nameValue.length != 0">
              <h5 class="multi-title">{{ 'object-info.specifications' | translate }}</h5>
              <ul class="ui-tree">
                <ng-container *ngFor="let item of list.nameValue">
                  <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                      type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>
            </div>

            <div class="multiple-inputs"
              *ngIf="list.performanceMatrix && list.performanceMatrix != null && list.performanceMatrix != undefined && list.performanceMatrix.length != 0">
              <h5 class="multi-title">{{ 'object-info.performance' | translate }}</h5>

              <ul class="ui-tree">
                <ng-container *ngFor="let item of list.performanceMatrix">
                  <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode1 let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                      type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>

            </div>







            <div class="multiple-inputs" *ngIf="list.warranty">
              <h5 class="multi-title">{{ 'object-info.warranty' | translate }}</h5>

              <ul class="ui-tree">
                <li *ngFor="let warrantyInfo of list.warrantyInfo">
                  <strong>{{ warrantyInfo.key }}:</strong>
                  <span *ngIf="warrantyInfo.key != 'Proof Of Purchase (Scan and Upload Bill or invoice etc)' && warrantyInfo.key != 'Coverage Start Date' && warrantyInfo.key != 'Coverage End Date'">
                    <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="text">
                  </span>
                  <span *ngIf="warrantyInfo.key == 'Coverage Start Date' || warrantyInfo.key == 'Coverage End Date'">
                    <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="date">
                  </span>
                  <span *ngIf="warrantyInfo.key == 'Proof Of Purchase (Scan and Upload Bill or invoice etc)'">
                    <!-- <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="file"> -->
                    <button (click)="addProofBtn()">{{ 'generic.file' | translate }}</button>
                    <input readonly type="text" class="file-name" *ngIf="proofFile && proofFile != ''"
                      value="{{proofFile}}">
                    <img *ngIf="proofFileType && proofFileType != ''" src="{{proofFilePath}}" alt="">
                    <!-- <span class="file-name" *ngIf="proofFile && proofFile != ''">{{proofFile}}</span> -->
                    <div hidden="true">
                      <input #proof type="file" id="add-proof-btn" hidden="true" (change)="onProofChange($event)">
                    </div>

                  </span>
                </li>
              </ul>
            </div>


            <div class="multiple-inputs" *ngIf="list.purchase">
              <h5 class="multi-title">{{ 'object-info.purchase' | translate }}</h5>

              <ul class="ui-tree">
                <li *ngFor="let purchaseInfo of list.purchaseInfo">
                  <strong>{{ purchaseInfo.key }}:</strong> <span><input [(ngModel)]="purchaseInfo.value"
                      style="width: 100%;" type="text"></span>
                </li>
              </ul>
            </div>






            <div class="check-box">
              <p><input type="checkbox" (click)="selectConnection($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="assetMonitoring" [(ngModel)]="assetMonitoring"> {{ 'object-info.assetMonitoring' |
                translate }}</p>
            </div>


            <div class="nameValue" *ngIf="assetMonitoring">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="">{{ 'object-info.assetMonitoringFrequency' | translate }}</label>
                    <input [(ngModel)]="assetMonitoringFrequency" [ngModelOptions]="{standalone: true}" type="number"
                      class="form-control">
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="">{{ 'object-info.assetMonitoringTimeSpan' | translate }}</label>
                    <input [(ngModel)]="assetMonitoringTimeSpan" [ngModelOptions]="{standalone: true}" type="number"
                      class="form-control">
                  </div>
                </div>
              </div>
              <div>
                <h5 class="multi-title">{{ 'object-info.connections' | translate }}</h5>

                <div class="row keys-content" *ngFor="let object of connectionsList;let i = index;let last = last">
                  <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                    <i class="bi bi-plus-circle" (click)="addConnection()"></i>
                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeConnection(i)"></i>
                  </div>
                  <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                    <i class="bi bi-dash-circle" (click)="removeConnection(i)"></i>
                  </div>
                  <div class="col-md-11 col-lg-11 keysBlock">
                    <div class="form-group">
                      <input [(ngModel)]="object.key" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter name" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="object.value" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter value" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="check-box">
              <p><input type="checkbox" (click)="selectAssetHealth($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="assetHealth" [(ngModel)]="assetHealth"> {{ 'object-info.assetHealth' | translate }}</p>
            </div>


            <div class="nameValue" *ngIf="assetHealth">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetHealth' | translate }}</h5>

                <div class="row keys-content" *ngFor="let object of assetHealthList;let i = index;let last = last">
                  <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                    <i class="bi bi-plus-circle" (click)="addAssetHealth()"></i>
                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeAssetHealth(i)"></i>
                  </div>
                  <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                    <i class="bi bi-dash-circle" (click)="removeAssetHealth(i)"></i>
                  </div>
                  <div class="col-md-11 col-lg-11 keysBlock">
                    <div class="form-group">
                      <input [(ngModel)]="object.key" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter name" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="object.value" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter value" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>





            <div class="check-box">
              <p><input type="checkbox" (click)="selectPerformance($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="performance" [(ngModel)]="performance"> {{ 'object-info.assetPerformance' | translate }}
              </p>
            </div>


            <div class="nameValue" *ngIf="performance">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                <div class="row keys-content">

                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                      <input [(ngModel)]="timeSpan" [ngModelOptions]="{standalone: true}" placeholder="enter time span"
                        type="text" class="form-control">
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.uom' | translate }}</label>
                      <select class="form-control" [(ngModel)]="uom" [ngModelOptions]="{standalone: true}">
                        <option value="" selected disabled> -- Select Uom --</option>
                        <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                      <input [(ngModel)]="expectedOutput" [ngModelOptions]="{standalone: true}"
                        placeholder="enter expected output" type="text" class="form-control">
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="check-box">
              <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="deployCurrentLocation"
                  [(ngModel)]="deployCurrentLocation">{{ 'object-info.deployCurrentLocation' | translate }}</p>
            </div>


            <div class="check-box">
              <p><input type="checkbox" (click)="selectParentAsset($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="isParentAssetId" [(ngModel)]="isParentAssetId">{{ 'object-info.parentAsset' | translate }}
              </p>
            </div>


            <div class="nameValue" *ngIf="isParentAssetId">
              <div>

                <div class="row keys-content">

                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.parentAsset' | translate }}</label>
                      <!-- <select name="" id="" [(ngModel)]="parentAssetId" class="form-control">
                        <option value="" selected disabled> -- select parent asset --</option>
                        <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
                      </select> -->

                      <ng-multiselect-dropdown [placeholder]="'Select Dashboard'" [settings]="parentDropdownSettings"
                        [data]="objectInfoList" [(ngModel)]="parentSelectedList" class="form-control"
                        style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                        (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>




            <div class="check-box">
              <p>{{ 'object-info.tags' | translate }} <i (click)="addTag()" class="bi bi-plus-circle"></i></p>
            </div>

            <div class="tags-block">
              <div class="form-group tag" *ngFor="let list of tags;let index = index">
                <input type="text" placeholder="enter tag" [(ngModel)]="list.tag" class="form-control">
                <span class="remove"><i (click)="removeTag(index)" class="bi bi-x-lg"></i></span>
              </div>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="remove()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addObjectInfo()" class="btn btn-primary">{{ 'generic.add' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>